import React from 'react'
import PropTypes from 'prop-types'
import { TenantMembersAddUserSection } from '../../TenantMembersAddUserSection'
import { TenantMembersTable } from '../../TenantMembersTable'

export const TenantMembersDialogComponent = ({ onClose }) => (
  <wb-modal mode="edit" class="tenant-members-dialog">
    <wb-modal-content
      headline="Edit members"
      style={{ height: '92%', overflow: 'hidden' }}
      class="tenant-members-dialog__content"
    >
      <div className="tenant-members-dialog__content-main">
        <div className="tenant-members-dialog__table">
          <TenantMembersTable />
        </div>
      </div>
    </wb-modal-content>
    <wb-modal-footer class="tenant-members-dialog__footer">
      <TenantMembersAddUserSection />
      <button
        type="button"
        className="wb-button wb-button--secondary wb-button--small"
        onClick={() => onClose()}
      >
        Close
      </button>
    </wb-modal-footer>
  </wb-modal>
)

TenantMembersDialogComponent.propTypes = {
  onClose: PropTypes.func,
}
